import React , { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useVendorOrderContext } from "../../../../components/Context/VendorOrderContext";
import { LuFileDown } from "react-icons/lu";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { getRateChart } from "../../../../services/VendorsService";
import { useLocation } from "react-router-dom";
import { getAllProduct } from "../../../../services/ProductService";
import { downloadVendorInvoice } from "../../../../services/InvoiceServices";
import { vendorStatusUpdate } from "../../../../services/VendorsService";
import "./VendorOrderDetails.css"
import { FiDownload } from "react-icons/fi";
import Toast from "../../../../components/Toast/Toast";



const VendorOrderDetails = () => {


  
  
  const navigate = useNavigate()
  const { orderId } = useParams();
  const { orders } = useVendorOrderContext();
  const [toasts, setToasts] = useState([]);


  const [spinnerOrder,setSpinnerOrder] = useState()
  const [dyerOrder,setDyerOrder] = useState()
 
  const location = useLocation();
  const { relatedOrders } = location.state || {};

  useEffect(() => {
    if (relatedOrders) {
      const foundSpinnerOrder = relatedOrders.find(o => o.vendorType === 'SPINNER');
      const foundDyerOrder = relatedOrders.find(o => o.vendorType === 'DYER');

      setSpinnerOrder(foundSpinnerOrder);
      setDyerOrder(foundDyerOrder);
    }
  }, [relatedOrders]);


  const [spinnerRateChart, setSpinnerRateChart] = useState({});
  const [dyerRateChart, setDyerRateChart] = useState({});

  const [totalsForDyer, setTotalsForDyer] = useState(null);
  const [totalsForSpinner, setTotalsForSpinner] = useState(null);
  
  const [productIdNameMap, setProductIdNameMap] = useState({});

  const [statusUpdates, setStatusUpdates] = useState({});
  const [modalData, setModalData] = useState({ isOpen: false, variantId: null, status: "", vendorOrderId: null });

  const [showReturnModal, setShowReturnModal] = useState(false);
  const [selectedReturnItem, setSelectedReturnItem] = useState(null);
  const [returnWeight, setReturnWeight] = useState('');


const initializeProductMap = async () => {
  try {
    const res = await getAllProduct();
    const products = res.data;
    const map = {};
    for (const product of products) {
      map[product.id] = product.productName;
    }
    setProductIdNameMap(map); // ✅ Update state
  } catch (error) {
    console.error('Failed to initialize product map:', error);
  }
};

useEffect(() => {
  initializeProductMap();
}, []);

const getProductNameById = (productId) => {
  return productIdNameMap[productId] || '';
};

  
  
  useEffect(() => {
    const fetchSpinnerRateChart = async () => {
      if (!spinnerOrder?.vendorId) return;
      try {
        const data = await getRateChart(spinnerOrder?.vendorId);
        setSpinnerRateChart(data.data.product || {});
      } catch (error) {
        console.error("Failed to fetch spinner rate chart:", error);
      }
    };
  
    fetchSpinnerRateChart();
  }, [spinnerOrder?.vendorId]);
  
  useEffect(() => {
    const fetchDyerRateChart = async () => {
      if (!dyerOrder?.vendorId) return;
      try {
        const data = await getRateChart(dyerOrder?.vendorId);
        setDyerRateChart(data.data.product || {});
      } catch (error) {
        console.error("Failed to fetch dyer rate chart:", error);
      }
    };
  
    fetchDyerRateChart();
  }, [dyerOrder?.vendorId]);


  useEffect(() => {
    if (
      dyerOrder?.vendorOrderVariantResponse &&
      Array.isArray(dyerRateChart) &&
      dyerRateChart.length > 0
    ) {
      const totals = calculateInvoiceTotals(
        dyerOrder.vendorOrderVariantResponse,
        dyerRateChart,
        extractStateFromAddress(dyerOrder?.vendorAddress)
      );
      setTotalsForDyer(totals);
    }
  }, [dyerOrder, dyerRateChart]);
  


  useEffect(() => {
    if (
      spinnerOrder?.vendorOrderVariantResponse &&
      Array.isArray(spinnerRateChart) &&
      spinnerRateChart.length > 0
    ) {
      const totals = calculateInvoiceTotals(
        spinnerOrder.vendorOrderVariantResponse,
        spinnerRateChart,
        extractStateFromAddress(spinnerOrder?.vendorAddress)
      );
      setTotalsForSpinner(totals);
    }
  }, [spinnerOrder, spinnerRateChart]);
  

  const vendorStatusFlow = [
    "PLACED",
    "CONFIRMED",
    "RECEIVED",
    "RETURNED",
    "REPLACED"
  ];
  
  const vendorStatusOptions = [
    { value: "PLACED", label: "Placed" },
    { value: "CONFIRMED", label: "Confirmed" },
    { value: "RECEIVED", label: "Received" },
    { value: "RETURNED", label: "Returned" },
    { value: "REPLACED", label: "Replaced" },
    { value: "CANCELLED", label: "Cancelled" }
  ];
  
  const statusClassMap = {
    PLACED: "vendor-order blue",
    CONFIRMED: "vendor-order yellow",
    RECEIVED: "vendor-order green",
    RETURNED: "vendor-order grey",
    REPLACED: "vendor-order purple",
    CANCELLED: "vendor-order red",
  };
  
  

  const calculateInvoiceTotals = (orderDetails, rateChart, vendorState) => {
    let subtotal = 0, cgst = 0, sgst = 0, igst = 0;

    for (const item of orderDetails) {
      const { rate, gst } = getRateForVariant(item.variantId, rateChart);
      const weight = item.vendorOrderWeight || 0;
      const baseAmount = rate * weight;
      subtotal += baseAmount;

      if (vendorState?.toLowerCase() === 'odisha') {
        cgst += (gst / 2 / 100) * baseAmount;
        sgst += (gst / 2 / 100) * baseAmount;
      } else {
        igst += (gst / 100) * baseAmount;
      }
    }

    return { subtotal, cgst, sgst, igst, total: subtotal + cgst + sgst + igst };
  };

  function extractStateFromAddress(address) {
    if (!address || typeof address !== "string") return null;
  
    // Normalize to lowercase and find "pin:"
    const lowerAddress = address.toLowerCase();
    const pinIndex = lowerAddress.indexOf("pin:");
  
    if (pinIndex === -1) return null;
  
    // Get the part before PIN
    const beforePin = address.slice(0, pinIndex).trim();
  
    // Split by comma and filter empty values
    const parts = beforePin.split(",").map(part => part.trim()).filter(Boolean);
  
    if (parts.length < 1) return null;
  
    // The state is typically the last non-empty part before PIN
    const state = parts[parts.length - 1];
  
    return state?.toLowerCase() || null;
  }
  


  const getRateForVariant = (variantId, rateChart) => {
    if (!Array.isArray(rateChart)) return {
      rate: 0,
      gst: 0,
      productName: "",
      colorName: "",
      colorHex: "",
    };
  
    for (const product of rateChart) {
      if (Array.isArray(product.variant)) {
        for (const variant of product.variant) {
          if (variant.variantId === variantId) {
            return {
              rate: variant.ratePerKg || 0,
              gst: product.gstOnProduct || 0,
              productName: product.productName || "",
              colorName: variant.color?.colorName || "",
              colorHex: variant.color?.colorCode || "",
            };
          }
        }
      }
    }
  
    return {
      rate: 0,
      gst: 0,
      productName: "",
      colorName: "",
      colorHex: "",
    };
  };
  
  
 const showToast = (message, type = "error") => {
      setToasts([{ message, type }]);
      setTimeout(() => setToasts([]), 3000);
    };

  return (
    <div className="order-details">
       <div className='top d-flex justify-content-between mb-2 mt-2' style={{cursor:'pointer'}}>
                    <div className="d-flex gap-2">
                  <span onClick={() => navigate(-1)}><IoArrowBackOutline size={25}/></span>
                
                  <h5>P.O: {relatedOrders[0].correlationId}</h5>
                  </div>

                  {/* <div className="d-flex gap-2">
                    <button className="btn bg-secondary-subtle">Print</button>
                    <button className="btn bg-secondary-subtle">Share</button>
                  </div> */}

        </div>

      <div className="row gx-2">  
      <div className=" mt-2 col-lg-5 col-md-12">
        <div className="bg-white p-2 rounded mt-2">
        <div className='d-flex justify-content-between'>
            <h6>Order for: <span className='text-primary'>{spinnerOrder?.vendorName}</span></h6>

            <div className='px-3 py-1 rounded-1' style={{border:'1px solid #93C5FD', backgroundColor:'#DBEAFE',color:'#1E40AF'}}>
                <p className='m-0'>Spinner</p>
            </div>

            </div>
            <div className="mt-2 overflow-x-auto">
            <table className="w-100 table" style={{ fontSize: "0.8rem", fontWeight: 500, overflowX: "auto" }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'start', verticalAlign: 'middle' }}  className="thtable" >Product</th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable">Size</th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable">Variant</th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable">Weight</th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable">Rate</th>
                {extractStateFromAddress(spinnerOrder?.vendorAddress) === "odisha" ?(
                    <>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable">CGST</th>
                    <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable">SGST</th>
                    </>
                ):
                (
                    <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable">IGST</th>
                )
                }
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable">Total</th>
                <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable">Status</th>
              </tr>
            </thead>
            <tbody>
            {Array.isArray(spinnerRateChart) && spinnerRateChart.length > 0 ? 
              (spinnerOrder.vendorOrderVariantResponse.map((item, index) => {
                const { rate, gst } = getRateForVariant(item.variantId, spinnerRateChart);
                const weight = item.vendorOrderWeight || 0;
                const baseAmount = weight * rate;
                const billingState = extractStateFromAddress(spinnerOrder?.vendorAddress)

              
                // Tax calculation
                let cgst = 0, sgst = 0, igst = 0;
                if (billingState === "odisha") {
                  cgst = (gst / 2 / 100) * baseAmount;
                  sgst = (gst / 2 / 100) * baseAmount;
                } else {
                  igst = (gst / 100) * baseAmount;
                }
            
                const totalAmount = baseAmount + cgst + sgst + igst;
            
                return (
                  <tr key={`spinner-${index}`}>
                    <td style={{ textAlign: 'start', verticalAlign: 'middle' }}>{getProductNameById(item.productId)}</td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{item.size}</td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{item.variantType}</td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                      {item.vendorOrderWeight}
                    </td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{rate.toFixed(2)}</td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{(gst/2).toFixed(1)}</td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{(gst/2).toFixed(1)}</td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{totalAmount.toFixed(2)}</td>
                    <td  style={{ justifyItems: 'center', alignContent:'center'}}  >
                    <select
                        value={item.status}
                        className={`form-select form-select  ${statusClassMap[item.status] || ''}`}
                        onChange={async (e) => {
                        const newStatus = e.target.value;

                        if (newStatus === "RETURNED") {
                          // Open modal and set current item
                          setSelectedReturnItem(item);
                          setShowReturnModal(true);
                          return;
                        }

                        const confirmMessage = `Are you sure you want to change the status from "${item.status}" to "${newStatus}"?`;
                        const confirmed = window.confirm(confirmMessage);
                        if (!confirmed) return;

                        const payload = [{
                          vendorOrderVariantId: item.vendorOrderVariantId,
                          status: newStatus,
                          reason: newStatus === "CANCELLED" ? "Vendor cancelled the order" : "Vendor accepted the order",
                          remark: newStatus === "CANCELLED" ? "Order not possible" : "Expected delivery within 7 days"
                        }];

                        try {
                          await vendorStatusUpdate(spinnerOrder.vendorOrderId, payload);
                          setSpinnerOrder((prev) => {
                            const updatedVariants = prev.vendorOrderVariantResponse.map((v) =>
                              v.vendorOrderVariantId === item.vendorOrderVariantId
                                ? { ...v, status: newStatus }
                                : v
                            );
                            return { ...prev, vendorOrderVariantResponse: updatedVariants };
                          });
                        } catch (error) {
                          showToast("Failed to update status. Please try again.", "error");
                        }
                      }}

                      >
                        {vendorStatusOptions.map(({ value, label }) => {
                          const currentStatus = item.status;

                          const currentIndex = vendorStatusFlow.indexOf(currentStatus);
                          const optionIndex = vendorStatusFlow.indexOf(value);

                          const isSame = value === currentStatus;
                          const isPlaced = currentStatus === "PLACED";
                          const isCancelled = currentStatus === "CANCELLED";
                          const isConfirmed = currentStatus === "CONFIRMED";
                          const isReceived = currentStatus === "RECEIVED";
                          const isReturned = currentStatus === "RETURNED";

                          let shouldEnable = false;

                          if (isCancelled) {
                            // Cancelled is final
                            shouldEnable = isSame;
                          } else if (isPlaced) {
                            // During PLACED show only CONFIRMED and CANCELLED
                            shouldEnable = value === "CONFIRMED" || value === "CANCELLED" || isSame;
                          }
                          else if (isReturned) {
                            // During PLACED show only CONFIRMED and CANCELLED
                            shouldEnable = "";
                          }
                          else if (isReceived) {
                        // During PLACED show only CONFIRMED and CANCELLED
                        // shouldEnable = value === "RETURNED" || value === "REPLACED" || isSame;
                          shouldEnable = optionIndex > currentIndex || isSame;
                          }
                          else if (isConfirmed) {
                            // After CONFIRMED, allow all next statuses (no cancel)
                            // shouldEnable = optionIndex > currentIndex || isSame;
                            shouldEnable = value === "RECEIVED"
                          } else {
                            // Allow only next immediate status (e.g., from REPLACED → DISPATCHED)
                            shouldEnable = optionIndex === currentIndex + 1 || isSame;
                          }

                          return (
                            <option key={value} value={value} disabled={!shouldEnable}>
                              {label}
                            </option>
                          );
                        })}
                      </select>


                    </td>

                  </tr>
                );
              })
              ) : (
                <tr>
                  <td colSpan={7}></td>
                </tr>
              )}
            </tbody>
          </table>
          </div>
        </div>


        <div className='bg-white rounded  p-3 mt-2'>
        
                    <div className='d-flex justify-content-between' style={{ fontSize: '1rem', fontWeight: 500 }}>
                            <h6>Payment</h6>
                           
                            <div className='bg-secondary-subtle rounded-circle p-2 text-dark d-flex justify-content-center align-items-center' style={{cursor:'pointer', width: '34px', height: '34px'}} onClick={()=>downloadVendorInvoice(spinnerOrder?.vendorOrderId)}><FiDownload size={18}/></div>
                        </div>
        
                    <table className="w-100 table border rounded mt-2" style={{ fontSize: '0.8rem', fontWeight: 500 }}>
                        {/* <thead className="thead-light">
                        <tr>
                            <th>Description</th>
                            <th>Details</th>
                            <th>Amount</th>
                        </tr>
                        </thead> */}
                        <tbody>
                        <tr>
                            <td>Subtotal</td>
                            <td>items {spinnerOrder?.vendorOrderVariantResponse.length}</td>
                            <td style={{textAlign:'end'}}>{totalsForSpinner?.subtotal.toFixed(0)}</td>
                        </tr>
                        {extractStateFromAddress(spinnerOrder?.vendorAddress) === 'odisha' ? (
                            <>
                            <tr>
                                <td>CGST</td>
                                <td></td>
                                <td style={{ textAlign: 'end' }}>₹{totalsForSpinner?.cgst?.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>SGST</td>
                                <td></td>
                                <td style={{ textAlign: 'end' }}>₹{totalsForSpinner?.sgst?.toFixed(2)}</td>
                            </tr>
                            </>
                        ) : (
                            <tr>
                            <td>IGST</td>
                            <td></td>
                            <td style={{ textAlign: 'end' }}>₹{totalsForSpinner?.igst?.toFixed(2)}</td>
                            </tr>
                        )}
                        </tbody>
                        <tfoot>
                        <tr>
                            <td colSpan="2" className="font-weight-bold">Total</td>
                            <td className="font-weight-bold" style={{textAlign:'end'}}>₹{totalsForSpinner?.total.toFixed(0)}</td>
                        </tr>
                        
                        </tfoot>
                    </table>
        
                           
                           
                    </div>


       

        </div>

        <div className='mt-2 col-lg-7 col-md-12'>
                    

          <div className="bg-white p-2 rounded mt-2">
        <div className='d-flex justify-content-between'>
            <h6>Order for: <span className='text-primary'>{dyerOrder?.vendorName}</span></h6>

            <div className='px-3 py-1  rounded-1' style={{border:'1px solid #FCD34D', backgroundColor:'#FEF3C7',color:'#92400E'}}>
                <p className='m-0'>Dyer</p>
            </div>

            </div>
           <div className="mt-2 overflow-x-auto">
    <table className="w-100 table" style={{ fontSize: "0.8rem", fontWeight: 500, overflowX: "auto" }}>
      <thead>
        <tr>
          <th style={{ textAlign: 'start', verticalAlign: 'middle' }}  className="thtable">Product</th>
          <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">Size</th>
          <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">Variant</th>
          <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">Color Name</th>
          <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">Color Code</th>
          <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">Weight</th>
          <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">Rate</th>
          {extractStateFromAddress(dyerOrder?.vendorAddress) === "odisha" ?(
              <>
               <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">CGST</th>
               <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">SGST</th>
               </>
          ):
          (
              <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">IGST</th>
          )
          }
         
          <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">Total</th>
          <th style={{ textAlign: 'center', verticalAlign: 'middle' }}  className="thtable text-center">Status</th>
        </tr>
      </thead>
      <tbody>
      {Array.isArray(dyerRateChart) && dyerRateChart.length > 0 ? 
        (dyerOrder?.vendorOrderVariantResponse.map((item, index) => {
          const { rate, gst ,colorName , colorHex} = getRateForVariant(item.variantId, dyerRateChart);
          const weight = item.vendorOrderWeight || 0;
          const baseAmount = weight * rate;
      
          const billingState = extractStateFromAddress(dyerOrder?.vendorAddress)

          console.log(billingState)

          // Tax calculation
          let cgst = 0, sgst = 0, igst = 0;
          if (billingState === "odisha") {
            cgst = (gst / 2 / 100) * baseAmount;
            sgst = (gst / 2 / 100) * baseAmount;
          } else {
            igst = (gst / 100) * baseAmount;
          }
      
          const totalAmount = baseAmount + cgst + sgst + igst;

          return (
            <tr key={`dyer-${index}`} >
              <td style={{ textAlign: 'start', verticalAlign: 'middle' }} className="">{getProductNameById(item.productId)}</td>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }} className=" text-center">{item.size}</td>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }} className=" text-center">{item.variantType}</td>
               <td style={{ textAlign: 'center', verticalAlign: 'middle' }} className=" text-center">{colorHex}</td>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                <div className="d-flex justify-content-center align-items-center gap-2">
                  {colorName}
                </div>
              </td>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }}  className=" text-center">{item.vendorOrderWeight}</td>
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }} className=" text-center">{rate.toFixed(2)}</td>
              {billingState?.toLowerCase() === "odisha"?(
                  <>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{(gst/2).toFixed(1)}</td>
                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{(gst/2).toFixed(1)}</td>
                  </>
              ):(
                  <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>{gst}</td>
              )
            }
              
              <td style={{ textAlign: 'center', verticalAlign: 'middle' }} className=" text-center">{totalAmount.toFixed(2)}</td>
              <td  style={{ justifyItems: 'center', alignContent:'center'}}  >
              <select
                value={item.status}
                className={`form-select form-select p-2 ${statusClassMap[item.status] || ''}`}
                onChange={async (e) => {
                  const newStatus = e.target.value;

                  if (newStatus === "RETURNED") {
                    setSelectedReturnItem(item);
                    setShowReturnModal(true);
                    return;
                  }

                  const confirmMessage = `Are you sure you want to change the status from "${item.status}" to "${newStatus}"?`;
                  const confirmed = window.confirm(confirmMessage);
                  if (!confirmed) return;

                  const payload = [{
                    vendorOrderVariantId: item.vendorOrderVariantId,
                    status: newStatus,
                    reason: newStatus === "CANCELLED" ? "Dyer cancelled the order" : "Dyer accepted the order",
                    remark: newStatus === "CANCELLED" ? "Order not possible" : "Expected delivery within 7 days"
                  }];

                  try {
                    await vendorStatusUpdate(dyerOrder.vendorOrderId, payload);
                    setDyerOrder((prev) => {
                      const updatedVariants = prev.vendorOrderVariantResponse.map((v) =>
                        v.vendorOrderVariantId === item.vendorOrderVariantId
                          ? { ...v, status: newStatus }
                          : v
                      );
                      return { ...prev, vendorOrderVariantResponse: updatedVariants };
                    });
                  } catch (error) {
                    showToast("Failed to update status. Please try again.", "error");
                  }
                }}
              >
                {vendorStatusOptions.map(({ value, label }) => {
                  const currentStatus = item.status;
                  const currentIndex = vendorStatusFlow.indexOf(currentStatus);
                  const optionIndex = vendorStatusFlow.indexOf(value);

                  const isSame = value === currentStatus;
                  const isPlaced = currentStatus === "PLACED";
                  const isCancelled = currentStatus === "CANCELLED";
                  const isConfirmed = currentStatus === "CONFIRMED";
                  const isReceived = currentStatus === "RECEIVED";
                  const isReturned = currentStatus === "RETURNED";

                  let shouldEnable = false;

                  if (isCancelled) {
                    shouldEnable = isSame;
                  } else if (isPlaced) {
                    shouldEnable = value === "CONFIRMED" || value === "CANCELLED" || isSame;
                  } else if (isReturned) {
                    shouldEnable = "";
                  } else if (isReceived) {
                    shouldEnable = optionIndex > currentIndex || isSame;
                  } else if (isConfirmed) {
                    shouldEnable = value === "RECEIVED";
                  } else {
                    shouldEnable = optionIndex === currentIndex + 1 || isSame;
                  }

                  return (
                    <option key={value} value={value} disabled={!shouldEnable}>
                      {label}
                    </option>
                  );
                })}
              </select>

              </td>
            </tr>
          );
        })
        ) : (
          <tr>
            <td colSpan={7}></td>
          </tr>
        )}
      </tbody>
    </table>
    </div>
        </div>
        
        
        
                    <div className='bg-white rounded p-3 mt-2'>
                        <div className='d-flex justify-content-between'style={{ fontSize: '1rem', fontWeight: 500 }}>
                            <h6>Payment</h6>
                           
                            <div className='bg-secondary-subtle rounded-circle p-2 text-dark d-flex justify-content-center align-items-center' style={{cursor:'pointer', width: '34px', height: '34px'}} onClick={()=>downloadVendorInvoice(dyerOrder?.vendorOrderId)}><FiDownload size={18}/></div>
                        </div>
        
                        <table className='w-100 table border rounded mt-2' style={{ fontSize: '0.8rem', fontWeight: 500 }}>
                            
                            <tbody>
                                 <tr>
                                    <td>Subtotal</td>
                                    <td>items {dyerOrder?.vendorOrderVariantResponse.length}</td>
                                    <td style={{textAlign:'end'}}>₹{totalsForDyer?.subtotal.toFixed(0)}</td>
                                </tr>
                                {extractStateFromAddress(dyerOrder?.vendorAddress) === 'odisha' ? (
                            <>
                            <tr>
                                <td>CGST</td>
                                <td></td>
                                <td style={{ textAlign: 'end' }}>₹{totalsForDyer?.cgst.toFixed(2)}</td>
                            </tr>
                            <tr>
                                <td>SGST</td>
                                <td></td>
                                <td style={{ textAlign: 'end' }}>₹{totalsForDyer?.sgst.toFixed(2)}</td>
                            </tr>
                            </>
                        ) : (
                            <tr>
                            <td>IGST</td>
                            <td></td>
                            <td style={{ textAlign: 'end' }}>₹{totalsForDyer?.igst.toFixed(2)}</td>
                            </tr>
                        )}
        
                                <tr>
                                    <td>Total</td>
                                    <td></td>
                                    <td style={{textAlign:'end'}}>₹{totalsForDyer?.total.toFixed(0)}</td>
                                    
                                </tr>
        
        
        
        
                            </tbody>
                        </table>
        
                      
        
                    </div>
        
        
        
        
              </div>
              </div>
              {showReturnModal && (
                <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
                  <div className="modal-dialog">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Enter Return Weight</h5>
                        <button type="button" className="btn-close" onClick={() => setShowReturnModal(false)}></button>
                      </div>
                      <div className="modal-body">
                        <input
                          type="number"
                          min="0"
                          className="form-control"
                          placeholder="Enter return weight (kg)"
                          value={returnWeight}
                          onChange={(e) => setReturnWeight(e.target.value)}
                        />
                      </div>
                      <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={() => setShowReturnModal(false)}>Cancel</button>
                        <button
                          className="btn btn-primary"
                          onClick={async () => {
                            if (!returnWeight || Number(returnWeight) <= 0) {
                              showToast("Please enter a valid return weight.", "error");
                              return;
                            }

                            const payload = [{
                              vendorOrderVariantId: selectedReturnItem.vendorOrderVariantId,
                              status: "RETURNED",
                              returnWeight: Number(returnWeight),
                              reason: "Vendor returned the item",
                              remark: `Returned ${returnWeight} kg`,
                            }];

                            try {
                              await vendorStatusUpdate(spinnerOrder.vendorOrderId, payload);
                              setSpinnerOrder((prev) => {
                                const updatedVariants = prev.vendorOrderVariantResponse.map((v) =>
                                  v.vendorOrderVariantId === selectedReturnItem.vendorOrderVariantId
                                    ? { ...v, status: "RETURNED" }
                                    : v
                                );
                                return { ...prev, vendorOrderVariantResponse: updatedVariants };
                              });
                              setShowReturnModal(false);
                              setReturnWeight('');
                            } catch (error) {
                              showToast("Failed to update status.", "error");
                            }
                          }}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

    
  {/* Toast Notification */}
     <div className="fixed top-4 right-4 z-50 space-y-2">
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        message={toast.message}
                        type={toast.type}
                        onClose={() =>
                            setToasts((prev) => prev.filter((t) => t.id !== toast.id))
                        }
                    />
                ))}
            </div>


    </div>
  );
};

export default VendorOrderDetails;
